var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "bootscreenshu-div" },
    [
      _c("div", { staticClass: "bootscreenshu-info" }, [
        _c("div", { staticClass: "info-left van-multi-ellipsis--l2" }, [
          _vm._v(" " + _vm._s(_vm.currentAddress || "") + " "),
        ]),
        _c("div", { staticClass: "info-right" }, [
          _c("div", { staticClass: "info-time" }, [
            _vm._v(_vm._s(_vm.timeString)),
          ]),
          _c("div", { staticClass: "info-date" }, [
            _vm._v(_vm._s(_vm.dateString)),
          ]),
        ]),
      ]),
      _c("div", { staticClass: "bootscreenshu-top" }, [
        _vm.headerLogo && _vm.headerLogo.length > 0
          ? _c("img", {
              staticClass: "top-logo",
              attrs: { src: _vm._f("imgFormat")(_vm.headerLogo), alt: "" },
            })
          : _c("div", { staticClass: "top-logo" }),
      ]),
      _c("div", { staticClass: "bootscreenshu-bgdiv" }, [
        _vm.bottomButtonArr.length > 0
          ? _c(
              "div",
              { staticClass: "bootscreenshu-tabdiv" },
              _vm._l(_vm.bottomButtonArr, function (item, index) {
                return _c(
                  "div",
                  {
                    key: "tabdiv-item" + index,
                    class:
                      _vm.selectIndex == index
                        ? "tabdiv-item-select"
                        : "tabdiv-item",
                    on: {
                      click: function ($event) {
                        return _vm.selectTabButton(index)
                      },
                    },
                  },
                  [_vm._v(" " + _vm._s(item) + " ")]
                )
              }),
              0
            )
          : _c("div", { staticClass: "bootscreenshu-tabdiv" }),
        _c("div", { staticClass: "bootscreenshu-paddingdiv" }, [
          _c("div", { staticClass: "bootscreenshu-maindiv" }, [
            _vm.bottomButtonArr.length > 0
              ? _c(
                  "div",
                  { staticClass: "bootscreenshu-content" },
                  [_c("router-view")],
                  1
                )
              : _vm._e(),
          ]),
        ]),
      ]),
      _c(
        "van-dialog",
        {
          attrs: {
            "show-confirm-button": false,
            closeOnClickOverlay: "",
            "show-cancel-button": false,
            width: "85%",
          },
          model: {
            value: _vm.show,
            callback: function ($$v) {
              _vm.show = $$v
            },
            expression: "show",
          },
        },
        [
          _c(
            "div",
            {
              staticClass: "dialog-signin-maindiv",
              on: {
                click: function ($event) {
                  _vm.show = false
                },
              },
            },
            [
              _c("div", { staticClass: "dialog-closebuttondiv" }, [
                _vm._v("点击任意处关闭"),
              ]),
              _c("div", {
                staticClass: "dialog-closebutton iconfont icon-icon_wrong",
                on: {
                  click: function ($event) {
                    _vm.show = false
                  },
                },
              }),
              _c("div", { staticClass: "dialog-maininfo" }, [
                _c("div", { staticClass: "maininfo_mess" }, [
                  _c("div", { staticClass: "maininfo_mess_imgcontent" }, [
                    _c("img", {
                      attrs: {
                        src: require("../../../public/img/product/bootScreen/icon-alert.png"),
                      },
                    }),
                  ]),
                  _c("p", { staticClass: "go_place" }, [
                    _vm._v(" " + _vm._s(_vm.attendInfo.name || "") + "学员"),
                    _c("br"),
                    _vm._v("请您前往"),
                    _c("span", [_vm._v(_vm._s(_vm.addressInfo.place || ""))]),
                    _vm._v("签到！ "),
                  ]),
                  _c("p", { staticClass: "now_place" }, [
                    _vm._v("当前位置：" + _vm._s(_vm.currentAddress || "")),
                  ]),
                ]),
                _c("div", { staticClass: "course_mess" }, [
                  _c("p", { staticClass: "course_title" }, [
                    _vm._v("您的课程信息如下："),
                  ]),
                  _c("div", { staticClass: "course_item" }, [
                    _c("p", { staticClass: "course_label iconfont icon-rili" }),
                    _c("p", { staticClass: "course_val" }, [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.dsf.date.format(
                              _vm.addressInfo.beginDateTime,
                              "mm月dd日 hh:ii"
                            )
                          ) +
                          " "
                      ),
                    ]),
                  ]),
                  _c("div", { staticClass: "course_item" }, [
                    _c("p", {
                      staticClass: "course_label iconfont icon-address",
                    }),
                    _c("p", { staticClass: "course_val" }, [
                      _vm._v(_vm._s(_vm.addressInfo.place || "")),
                    ]),
                  ]),
                  _c("div", { staticClass: "course_item" }, [
                    _c("p", { staticClass: "course_label iconfont icon-xxkc" }),
                    _c("p", { staticClass: "course_val" }, [
                      _vm._v(" " + _vm._s(_vm.addressInfo.name || "") + " "),
                    ]),
                  ]),
                  _c("div", { staticClass: "course_item" }, [
                    _c("p", {
                      staticClass: "course_label iconfont icon-jiaoshi",
                    }),
                    _c("p", { staticClass: "course_val" }, [
                      _vm._v(_vm._s(_vm.addressInfo.speakerText || "")),
                    ]),
                  ]),
                ]),
              ]),
            ]
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }